<template>
    <v-container fluid class="py-0 px-0 mx-0">
        <v-row no-gutters class="mb-0">
            <v-col xl=12 lg=12 md=12 sm=12 xs=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
                <v-img
                    height="auto"
                    width="100%"
                    :src="require('@/assets/homepage-banner-members-paron-v2.jpg')"/>
            </v-col>
            <v-col cols=12 :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'" style="color:#1b2f5a;" align=center>
                <div class="my-16">
                    Κάθε μέλος της Paron Card, <span class="font-weight-bold">ιδιώτης ή επαγγελματίας</span>, μπορεί να έχει προνομιακές τιμές <span class="font-weight-bold">B2B</span>
                    τις οποίες εξασφαλίζει η διαμεσολαβητική Members Paron σε μεγάλες συνεργαζόμενες επιχειρήσεις
                    είτε αυτές ανήκουν στο δίκτυο συνεργαζόμενων εταιρειών με τον Οργανισμό Π.Α.Ρ.Ο.Ν. είτε δεν ανήκουν (Β2Β).
                </div>
                <div class="mt-16">
                    Περισσότερες πληροφορίες σχετικά με την Paron Card και πως μπορείς να την αποκτήσεις.
                </div>
                <v-btn
                    class="mt-3"
                    color="#1b2f5a"
                    dark
                    @click="$router.push({path: '/AboutUs'})"
                >
                    Περισσότερα
                </v-btn>
                <div class="mt-16">
                    Για να απολαύσετε τα προνόμια της Members Paron ακολουθήστε τα παρακάτω βήματα.
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-10" justify="center" align="center" :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 3 : 3">
                <v-divider class="custom-divider my-5"></v-divider>
            </v-col>
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 6 : 6" style="font-weight: 600; color:#1b2f5a;" :style="$vuetify.breakpoint.mobile ? 'font-size: 22px' : 'font-size: 28px'">
                Βήματα
            </v-col>
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 3 : 3">
                <v-divider class="custom-divider my-5"></v-divider>
            </v-col>
            <v-col
                cols="12"
            >
                <div class="text-center font-weight-bold" style="color: #ad282d" :style="$vuetify.breakpoint.mobile ? 'font-size: 20px' : 'font-size: 26px'">Από συνεργαζόμενη επιχείρηση</div>
                <v-timeline>
                    <v-timeline-item
                    v-for="(step, i) in steps"
                    :key="i"
                    :color="step.color"
                    small
                    >
                    <template v-slot:opposite>
                        <span
                            :class="`headline font-weight-bold`"
                            :style="`color: ${step.color}`"
                        >Βήμα {{ step.step }}</span>
                    </template>
                    <div class="py-4">
                        <div :style="`${($vuetify.breakpoint.mobile ? 'font-size: 18px;' : 'font-size: 28px;')} color: ${step.color} !important;`" style="word-break: break-word;">
                            {{ step.description }}
                        </div>
                    </div>
                    </v-timeline-item>
                </v-timeline>
            </v-col>
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 3 : 3" class="mt-10">
                <v-divider class="custom-divider my-5"></v-divider>
            </v-col>
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 6 : 6" style="font-weight: 600; color:#1b2f5a;" :style="$vuetify.breakpoint.mobile ? 'font-size: 22px' : 'font-size: 28px'" class="mt-10">
                Εναλλακτικά
            </v-col>
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 3 : 3" class="mt-10">
                <v-divider class="custom-divider my-5"></v-divider>
            </v-col>
            <v-col
                cols="12"
            >
                <!-- <div class="text-center font-weight-bold" style="color: #ad282d" :style="$vuetify.breakpoint.mobile ? 'font-size: 20px' : 'font-size: 26px'">Από επιχείρηση η οποία δεν ανήκει στο δίκτυο επιχειρήσεων</div> -->
                <v-timeline>
                    <v-timeline-item
                    v-for="(step, i) in esteps"
                    :key="i"
                    :color="step.color"
                    small
                    >
                    <template v-slot:opposite>
                        <span
                            :class="`headline font-weight-bold`"
                            :style="`color: ${step.color}`"
                        >Βήμα {{ step.step }}</span>
                    </template>
                    <div class="py-4">
                        <div :style="`${($vuetify.breakpoint.mobile ? 'font-size: 18px;' : 'font-size: 28px;')} color: ${step.color} !important;`" style="word-break: break-word;">
                            {{ step.description }}
                        </div>
                    </div>
                    </v-timeline-item>
                </v-timeline>
            </v-col>
            <v-col cols="12" align=center>
                <span @click="$router.push({path: '/Terms'})" style="color: #ad282d !important; text-decoration: underline; cursor: pointer;">*Ισχύουν όροι και προϋποθέσεις</span>
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-10" justify="center" align="center" :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 3 : 3">
                <v-divider class="custom-divider my-5"></v-divider>
            </v-col>
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 6 : 6" style="font-weight: 600; color:#1b2f5a;" :style="$vuetify.breakpoint.mobile ? 'font-size: 22px' : 'font-size: 28px'">
                Επιχειρήσεις - Εκπτώσεις
            </v-col>
            <v-col justify="center" align="center" :cols="$vuetify.breakpoint.mobile ? 3 : 3">
                <v-divider class="custom-divider my-5"></v-divider>
            </v-col>
            <v-col 
                v-for="partner in partners.slice(0,6)" 
                :key="partner.id" 
                :cols="$vuetify.breakpoint.xs ? 12 : ($vuetify.breakpoint.mdAndDown ? 6 : 4)"
                class="mt-10"
            >
                <v-row justify="center" align="center" class="my-0 mx-0" @click="goToPartner(partner.id)">
                    <v-col justify="center" align="center" cols=12>
                        <router-link :to="`/Partner?id=${partner.id}`">
                            <v-img
                                height="150px"
                                width="250px"
                                contain
                                :src="getImage(partner)"
                            >
                            </v-img>
                        </router-link>
                    </v-col>
                </v-row>
            </v-col>
            <router-link style="text-decoration: none;" to="/Partners">
                <v-btn
                    color="#1b2f5a"
                    dark
                    x-large
                    style="text-transform: none !important;"
                    class="my-10"
                >
                    Περισσότερα
                </v-btn>
            </router-link>
        </v-row>
    </v-container>
</template>    

<script>
import restApi from "@/rest-api"

export default {
    data() {
        return {
            esteps: [
                {
                    color: '#1b2f5a',
                    step: '1',
                    description: 'Επιλέγετε στο κατάστημα της συνεργαζόμενης επιχείρησης τα είδη που σας ενδιαφέρουν.'
                },
                {
                    color: '#ad282d',
                    step: '2',
                    description: 'Αποστέλλετε την λίστα με τα προϊόντα και τα link από το site της συνεργαζόμενης επιχείρησης με email στο contact@paron-card.gr'
                },
                {
                    color: '#1b2f5a',
                    step: '3',
                    description: 'H Members Paron σας ενημερώνει για την προσφορά που σας έχει εξασφαλίσει ως μέλος της Paron Card.'
                }
                // {
                //     color: '#ad282d',
                //     step: '4',
                //     description: 'Πληρώνετε ηλεκτρονικά μέσω του site της Members Paron το ποσό της παραγγελίας.'
                // },
                // {
                //     color: '#1b2f5a',
                //     step: '5',
                //     description: 'Η Members Paron ενημερώνει την συνεργαζόμενη επιχείρηση για την εξόφληση της παραγγελίας και το μέλος παραλαμβάνει την παραγγελία του.'
                // },
                // {
                //     color: '#ad282d',
                //     step: '6',
                //     description: 'Η Members Paron εκδίδει προς το μέλος της Paron Card τιμολόγιο ή απόδειξη λιανικής.'
                // }
            ],
            steps: [
                {
                    color: '#1b2f5a',
                    step: '1',
                    description: 'Επιλέγετε στο κατάστημα της συνεργαζόμενης επιχείρησης τα είδη που σας ενδιαφέρουν.'
                },
                {
                    color: '#ad282d',
                    step: '2',
                    description: 'Παίρνετε την έκπτωση που έχει συμφωνηθεί με την εκάστοτε επιχείρηση ως μέλος της Paron Card.'
                }
                // {
                //     color: '#1b2f5a',
                //     step: '3',
                //     description: 'Πληρώνετε ηλεκτρονικά μέσω του site της Members Paron το ποσό της παραγγελίας.'
                // },
                // {
                //     color: '#ad282d',
                //     step: '4',
                //     description: 'Η Members Paron ενημερώνει την συνεργαζόμενη επιχείρηση για την εξόφληση της παραγγελίας και το μέλος παραλαμβάνει την παραγγελία του, με αντίγραφο τιμολογίου προς την Members Paron.'
                // },
                // {
                //     color: '#1b2f5a',
                //     step: '5',
                //     description: 'Η Members Paron εκδίδει προς το μέλος της Paron Card τιμολόγιο ή απόδειξη λιανικής.'
                // },
            ],
            teams:[],
            partners:[],
            menu: [
                {
                    route: 'HomePage', 
                    title: 'Αρχικη',
                    entitle: 'Home'
                }, 
                {
                    route: 'Teams',
                    title: 'Σωματεια',
                    entitle: 'Teams'
                },
                {
                    title: 'Paron',
                },
                { 
                    route: 'Partners',
                    title: 'Συνεργατες',
                    entitle: 'Partners'
                },
                { 
                    route: 'News',
                    title: 'Νεα',
                    entitle: 'News'
                },
            ],
        }
    },
    created() {
      this.fetchPartners()
    },
    computed: {
        language() {
            return this.$store.getters.getLanguage.language
        },
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        goToTeam(id) {
            this.$router.push({path: 'Team', query: { id: id }});
        },
        getImage(entity) {
            var image = entity.image;
            if(image) {
                return `https://dev.paron-card.gr/uploads/images/${image.imageName}`
            } else {
                return require('@/assets/MEMBERSPARON_LOGO.svg')
            }
        },
        fetchPartners() {
            var search = `/partner/filtered`;
            restApi
            .post(search, {'b2b': true})
            .then(response => {
                this.partners = response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },
        goToPartner(id) {
            this.$router.push({path: 'Partner', query: { id: id }});
        },
    }
}
</script>

<style lang="scss" scoped>

@media only screen and (max-width: 600px){
    .left-text {
        margin-bottom: 0px;
        text-align: center;
    }

    .right-text {
        margin-top: 0px;
        text-align: center;
    }
}

@media only screen and (min-width: 600px){
    .left-text {
        padding-bottom: 300px;
    }

    .right-text {
        padding-top: 300px;
    }
}

@media only screen and (max-width: 600px){
    .partners {
        border-radius: 0% 0% / 0% 0%;
    }

    .teams {
        border-radius: 0% 0% / 0% 0%;
    }
}

@media only screen and (min-width: 600px){
    .partners {
        padding-top:10px; 
        border-radius: 20% 50% / 40% 10%;
    }

    .teams {
        border-radius: 50% 20% / 10% 40%;
    }
}

@media only screen and (min-width: 600px){
    .partners {
        height:90vh; 
    }
}

@media only screen and (max-width: 600px){
    .partners {
        height:120vh; 
    }
}

.partners {
    background-color: #ad282d; 
    color:white; 
}

@media only screen and (min-width: 600px){
    .teams {
        height:90vh; 
    }
}

@media only screen and (max-width: 600px){
    .teams {
        height:120vh; 
    }
}

.teams {
    background-color: #1b2f5a; 
    color:white; 
}

@media only screen and (min-width: 600px){
    .carousel-img {
        width: 20vw;
    }
}

@media only screen and (max-width: 600px){
    .carousel-img {
        width: 100vw;
    }
}

.custom-divider {
    border-width: 1px;
    height: 70px;
    border-color: #1b2f5a;
}

.vertical-divider {
    border-width: 1px;
    height: 150px;
    border-color: #1b2f5a;
}

</style>